import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';

import { VpTabButtonGroup } from '@vp-ui/components';
import VpMediaInfoMenu from '@vp-ui/widgets/VpMediaTable/VpMediaInfoMenu';
import VpAttachmentInfoMenu from '@vp-ui/widgets/VpMediaTable/VpAttachmentInfoMenu';
import VpMediaInfoPreview from '@vp-ui/dialogs/VpMediaSubmissionDetailsDialog/VpMediaInfoPreview';
import VpMediaInfoDetails from '@vp-ui/dialogs/VpMediaSubmissionDetailsDialog/VpMediaInfoDetails';
import VpMediaInfoCaptions from '@vp-ui/dialogs/VpMediaSubmissionDetailsDialog/VpMediaInfoCaptions';
import VpMediaInfoTranslation from '@vp-ui/dialogs/VpMediaSubmissionDetailsDialog/VpMediaInfoTranslation';
import VpMediaInfoPublish from '@vp-ui/dialogs/VpMediaSubmissionDetailsDialog/VpMediaInfoPublish';
import { useMediaTableContext } from '@src/hooks/contexts';

const boxStyles = {
  flex: 1,
  padding: '25px',
  overflowY: 'auto',
  minHeight: 0
};
const stackStyles = {
  gap: '25px'
};

const VpMediaInfo = ({ media }) => {
  const isVideo = !!media?.mediaId;
  const mediaId = media?.mediaId || media?.attachmentId;
  const [selectedTab, setSelectedTab] = useState(0);
  const { pendingTab, setPendingTab } = useMediaTableContext();

  useEffect(() => {
    setSelectedTab(0);
  }, [mediaId]);

  useEffect(() => {
    if (pendingTab !== null) {
      setSelectedTab(pendingTab);
      setPendingTab(null);
    }
  }, [pendingTab, setPendingTab]);

  return (
    <Box sx={boxStyles}>
      <Stack sx={stackStyles}>
        <Stack direction="row" alignItems="center" gap={1} justifyContent="space-between">
          {isVideo ? (
            <VpTabButtonGroup
              first="Preview"
              second="Caption"
              third="Translate"
              fourth="Publish"
              selected={selectedTab}
              onSelect={setSelectedTab}
            />
          ) : (
            <VpTabButtonGroup
              first="Preview"
              second="Details"
              selected={selectedTab !== 0}
              onSelect={(val) => setSelectedTab(val ? 1 : 0)}
            />
          )}
          <Stack direction="row" gap="5px">
            {isVideo ? <VpMediaInfoMenu media={media} /> : <VpAttachmentInfoMenu media={media} />}
          </Stack>
        </Stack>
        {selectedTab === 0 && <VpMediaInfoPreview key={mediaId} media={media} />}
        {selectedTab === 1 && isVideo && <VpMediaInfoCaptions key={mediaId} media={media} />}
        {selectedTab === 1 && !isVideo && <VpMediaInfoDetails key={mediaId} media={media} />}
        {selectedTab === 2 && isVideo && <VpMediaInfoTranslation key={mediaId} media={media} />}
        {selectedTab === 3 && isVideo && <VpMediaInfoPublish key={mediaId} media={media} />}
      </Stack>
    </Box>
  );
};

VpMediaInfo.propTypes = {
  media: PropTypes.shape({
    mediaId: PropTypes.string,
    attachmentId: PropTypes.string
  })
};
export default VpMediaInfo;



// WEBPACK FOOTER //
// ./src/vp-ui/dialogs/VpMediaSubmissionDetailsDialog/VpMediaInfo.jsx